import React from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';
import { getPropertyName } from 'epic-games-nav/app/scripts/utils/epicPropertyInspector';
import defaultMessages from './constants/defaultMessages';
import Social from './components/social/Social';
import UpButton from './components/button/UpButton';
import Copyright from './components/copyright/Copyright';
import FooterLinks from './components/links/FooterLinks';
import Legal from './components/legal/Legal';
import Tags from './components/legal/Tags';
import NewsLetter from './components/newsLetter/NewsLetter';

//sass is imported with components/componentStyles.js

const versionJson = require('../../version.json');

if (!root._epicGamesFooter) {
    root._epicGamesFooter = {};
}

export default class EpicGamesFooter extends React.Component {
    constructor(props) {
        super(props);

        this.cache = {}; //holds onto messages object
    }

    static propTypes = {
        links: PropTypes.array,
        logos: PropTypes.array,
        epicPropertyName: PropTypes.string,
        epicPropertyClasses: PropTypes.string,
        socialLinks: PropTypes.array,
        legalTags: PropTypes.array,
        copyrights: PropTypes.array,
        messages: PropTypes.object,
        upOnClick: PropTypes.func,
        callToAction: PropTypes.object,
        moreLegalLinks: PropTypes.array,
        hideDefaultTermsPolicy: PropTypes.bool,
        newLineCopyrights: PropTypes.bool,
        enableNewsLetter: PropTypes.bool,
        isLoggedIn: PropTypes.bool,
        email: PropTypes.string,
        newsLetterConfigs: PropTypes.object,
        i18n: PropTypes.object
    };

    componentDidMount() {
        //allow external sites to apply logic when the footer is rendered
        if (typeof root._egFooterReadyCallback === 'function') {
            root._egFooterReadyCallback();
            root._egFooterReadyCallbackRun = true;
        } else {
            //start loop in case callback is created late
            let readyChecks = 0;
            const readyCheck = setInterval(() => {
                try {
                    readyChecks += 1;
                    if (root && root._egFooterReadyCallback && typeof root._egFooterReadyCallback === 'function') {
                        root._egFooterReadyCallback();
                        root._egFooterReadyCallbackRun = true;
                        clearInterval(readyCheck);
                    }
                    if (readyChecks > 10) {
                        clearInterval(readyCheck);
                    }
                } catch (e) {
                    clearInterval(readyCheck);
                }
            }, 500);
        }
        root._egFooterReadyCallbackCalled = true;
    }


    /**
     * Merges the default messages with the props passed into the component if any. Will cache the result to make
     * future renders much faster rather than merging every time.
     *
     * Checks the props for valid message constants otherwise returns the default values
     */
    getMessages() {
        let m = {};

        //check cache to see if props have not changed and skip the iteration
        if (this.props.messages && this.props.messages.asMutable && this.props.messages === this.cache.messages) {
            m = this.cache.m;
        } else {
            if (this.props.messages) {
                for (const key in defaultMessages) {
                    if (typeof key === 'string' && this.props.messages[key] && this.props.messages[key].length) {
                        m[key] = this.props.messages[key];
                    } else {
                        m[key] = defaultMessages[key];
                    }
                }
            } else {
                m = defaultMessages;
            }

            this.cache.messages = this.props.messages;
            this.cache.m = m;
        }
        return m;
    }

    render() {
        const epicPropertyName = getPropertyName(this.props.epicPropertyName || '');
        if (!epicPropertyName) {
            console.error('[EGF] Failed to initialize properly! Missing a valid epicPropertyName');
        }

        const epicPropertyClasses = this.props.epicPropertyClasses || '';

        const links = this.props.links || [];
        const socialLinks = this.props.socialLinks || [];
        const legalTags = this.props.legalTags || [];
        const copyrights = this.props.copyrights || [];
        const messages = this.getMessages();
        let callToAction = this.props.callToAction || {};
        const moreLegalLinks = this.props.moreLegalLinks || [];
        const hideDefaultTermsPolicy = this.props.hideDefaultTermsPolicy;
        const newLineCopyrights = this.props.newLineCopyrights || false;
        const newsLetterConfigs = this.props.newsLetterConfigs || {};
        const enableNewsLetter = (this.props.enableNewsLetter && newsLetterConfigs.enableNewsLetterCMS) || false;
        const i18n = this.props.i18n || {};
        const isLoggedIn = this.props.isLoggedIn || false;
        const email = this.props.email || '';
        const buttonMargin = legalTags.length === 0 && links.length === 0;
        let showNewsLetter = false;

        if (enableNewsLetter) {
            if (newsLetterConfigs.loginRequired) {
                showNewsLetter = isLoggedIn;
            } else {
                showNewsLetter = true;
            }
        }
        /**
         * TON-34803 Set CTA to null for UE if footerNewsletter is enabled.
         * Otherwise it will render two signup newsletters, one for sailthru and one for mailchimp under /epic-games-footer
         */
        if (epicPropertyName === 'unreal_engine' && enableNewsLetter) {
            callToAction = null;
        }
        return (
            <div className={`egh-theme ${epicPropertyName}`}>
                <footer
                    id="egf"
                    className={`egf container-fluid bg-color mobile-border-color ${epicPropertyName} ${epicPropertyClasses}`}
                    data-version={versionJson.version || ''}>
                    <div className="row">
                        <Social socialLinks={socialLinks} />
                        <UpButton
                            buttonMargin={buttonMargin}
                            onClick={this.props.upOnClick} />
                    </div>

                    <div className="row">
                        <FooterLinks links={links} />
                        {showNewsLetter ?
                            <NewsLetter
                                enableNewsLetter={enableNewsLetter}
                                isLoggedIn={isLoggedIn}
                                email={email}
                                newsLetterConfigs={newsLetterConfigs}
                                epicPropertyName={epicPropertyName}
                                i18n={i18n} /> : null}
                        <Tags legalTags={legalTags} callToAction={callToAction} />
                    </div>

                    <hr className="mobile-border-color" />

                    <div className="row copyright">
                        <Copyright copyrights={copyrights} newLineCopyrights={newLineCopyrights} />
                    </div>

                    <div className="row">
                        <Legal
                            logos={this.props.logos}
                            tos={messages.tos}
                            privacy={messages.privacy}
                            moreLegalLinks={moreLegalLinks}
                            hideDefaultTermsPolicy={hideDefaultTermsPolicy} />
                    </div>
                </footer>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/scripts/EpicGamesFooter.js